<script setup lang="ts">
  import { computed } from "vue";
  import Simplebar from "simplebar-vue";
  import "simplebar-vue/dist/simplebar.min.css";
  // import { $t } from '@/locales';

  interface Props {
    collapsed?: boolean;
    direction: any;
  }
  const props = defineProps<Props>();
  defineOptions({
    name: "SimpleScrollbar",
  });
  // Fix: Create a computed property for the docs URL
  const docsUrl = computed(() => {
    // Safe check for SSR environments where window might not exist
    if (typeof window !== "undefined") {
      // Extract main domain from hostname
      const hostname = window.location.hostname;
      const parts = hostname.split(".");

      // If we have a subdomain, take only the main domain parts
      // For example, from chat.avalai.ir, get avalai.ir
      let mainDomain;
      if (parts.length > 2) {
        mainDomain = parts.slice(-2).join(".");
      } else {
        mainDomain = hostname;
      }

      return `https://docs.${mainDomain}/`;
    }
    return "https://docs.avalai.ir/"; // Fallback URL
  });
</script>

<template>
  <div class="h-full flex flex-col flex-1-hidden">
    <Simplebar class="h-full">
      <slot />
    </Simplebar>

    <div class="status-link-container" :style="{ direction: props.direction }">
      <a
        :href="docsUrl"
        target="_blank"
        rel="noopener"
        class="status-link"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M4 4a2 2 0 0 1 2-2h8a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm13.586 4L14 4.414V8zM12 4H6v16h12V10h-5a1 1 0 0 1-1-1zm-4 9a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1"
          />
        </svg>
        <template v-if="!props.collapsed">
          <span class="status-text">{{ $t("common.docs") }}</span>
        </template>
      </a>
      <a
        href="https://status.avalai.ir"
        target="_blank"
        rel="noopener"
        class="status-link"
      >
        <svg
          class="w-6"
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          height="20px"
          viewBox="0 0 16 16"
        >
          <rect width="16" height="16" fill="none" />
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M7.999 1a.75.75 0 0 1 .715.521L12 11.79l1.286-4.018A.75.75 0 0 1 14 7.25h1.25a.75.75 0 0 1 0 1.5h-.703l-1.833 5.729a.75.75 0 0 1-1.428 0L8.005 4.226l-2.29 7.25a.75.75 0 0 1-1.42.03L3.031 8.03l-.07.208a.75.75 0 0 1-.711.513H.75a.75.75 0 0 1 0-1.5h.96l.578-1.737a.75.75 0 0 1 1.417-.02L4.95 8.919l2.335-7.394A.75.75 0 0 1 7.999 1"
            clip-rule="evenodd"
          />
        </svg>
        <template v-if="!props.collapsed">
          <span class="status-text">{{ $t("common.systemStatus") }}</span>
          <div class="status-indicator"></div>
        </template>
      </a>
    </div>
  </div>
</template>

<style scoped></style>
